import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { commentsApi } from '../api';

export function commentsQueryKey(docId) {
    return ['comments', docId];
}

export function useComments(docId) {
    return useQuery({
        queryKey: commentsQueryKey(docId),
        queryFn: async () => {
            const data = await commentsApi.list(docId);
            if (!data.success) throw new Error(data.error || 'Failed to load comments');
            return data.comments;
        },
        enabled: !!docId,
    });
}

export function useCreateComment() {
    return useMutation({
        mutationFn: (payload) => commentsApi.create(payload),
    });
}

export function useUpdateComment() {
    return useMutation({
        mutationFn: ({ commentId, content }) => commentsApi.update(commentId, content),
    });
}

export function useUpdateCommentMetadata() {
    return useMutation({
        mutationFn: ({ commentId, metadata }) => commentsApi.updateMetadata(commentId, metadata),
    });
}

export function useReactToComment() {
    return useMutation({
        mutationFn: ({ commentId, userId }) => commentsApi.react(commentId, userId),
    });
}

export function useDeleteComment() {
    return useMutation({
        mutationFn: (commentId) => commentsApi.remove(commentId),
    });
}

// Fase 5.8 — extraído del `apiClient.patch` + `invalidateQueries` inline que tenía `CommentItem`
// en `Comments.jsx`. El candado (ícono/tooltip/URL) lo re-resuelve el backend, así que se
// invalida y se refetchea en vez de duplicar esa lógica en el cliente.
export function useSetCommentMediaVisibility() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ commentId, mediaKey, access }) => commentsApi.toggleMediaVisibility(commentId, mediaKey, access),
        onSuccess: (_data, { documentId }) => qc.invalidateQueries({ queryKey: commentsQueryKey(documentId) }),
    });
}

export function useMarkCommentsAsRead() {
    return useMutation({
        mutationFn: (commentIds) => commentsApi.markAsRead(commentIds),
    });
}
